'use strict';
'use es6';

/**
 * Returns `true` if value is an Array.
 * 
 * @param {any} value
 * @return {boolean}
 */

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isArray;
function isArray(value) {
  return Array.isArray(value);
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/transmute/static-2.3/isArray.js
// module id = 368
// module chunks = 0 1